// extracted by mini-css-extract-plugin
module.exports = {"base":"chip_base__3hm_Z"};